import { palette } from '@versports/theme'
import type { ChartOptions } from 'chart.js'

/** `#rrggbb` → `rgba(...)`. Chart.js necesita colores translúcidos para
 * rellenos/áreas y el theme sólo expone hex opaco. */
export function withAlpha(hex: string, alpha: number): string {
  const m = /^#([0-9a-f]{6})$/i.exec(hex)
  if (!m) return hex
  const body = m[1]!
  const r = parseInt(body.slice(0, 2), 16)
  const g = parseInt(body.slice(2, 4), 16)
  const b = parseInt(body.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/** Ejes/leyenda/tooltip con los tokens del theme. Todo gráfico del web-app
 * arranca de acá para que la familia visual sea una sola (mismos grises de
 * grilla, mismo color de ticks) en lugar de repetir el bloque `scales` con
 * literales en cada archivo. */
export function baseChartOptions(): ChartOptions<'line' | 'bar'> {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'nearest', intersect: false },
    plugins: {
      legend: { labels: { color: palette.textSecondary, boxWidth: 12 } },
      tooltip: {
        backgroundColor: palette.surfaceElevated,
        titleColor: palette.textPrimary,
        bodyColor: palette.textSecondary,
        borderColor: withAlpha(palette.outline, 0.8),
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        ticks: { color: palette.textMuted },
        grid: { color: withAlpha(palette.outline, 0.4) },
      },
      y: {
        ticks: { color: palette.textMuted },
        grid: { color: withAlpha(palette.outline, 0.4) },
      },
    },
  }
}
